// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1yjQB","label":"CategoryService_label__Jtriu","location":"CategoryService_location__fGeHB"};